/**
 * WhatsApp normalization and URL helpers (Milestone 11).
 */
import { formatVehicleTitle } from "./automapListing/listingFormatters";

const COLOMBIA_COUNTRY_CODE = "57";

export function normalizeWhatsappNumber(raw) {
  if (!raw) return "";
  let digits = String(raw).replace(/\D/g, "");
  if (!digits) return "";

  if (digits.startsWith(COLOMBIA_COUNTRY_CODE) && digits.length >= 12) {
    return digits;
  }

  if (digits.length === 10 && digits.startsWith("3")) {
    return `${COLOMBIA_COUNTRY_CODE}${digits}`;
  }

  if (digits.length >= 10) return digits;
  return digits;
}

export function isValidWhatsappNumber(normalized) {
  const digits = String(normalized || "").replace(/\D/g, "");
  return digits.length >= 10 && digits.length <= 15;
}

export function buildWhatsappHref(number, message) {
  const digits = normalizeWhatsappNumber(number);
  if (!isValidWhatsappNumber(digits)) return null;
  const encoded = encodeURIComponent(message || "");
  return `https://wa.me/${digits}?text=${encoded}`;
}

export function buildDealerContactMessage({ listing, detailUrl }) {
  const vehicleTitle = listing ? formatVehicleTitle(listing, { fallback: "" }) : null;

  if (vehicleTitle && detailUrl) {
    return `Hola, vi este vehículo en AutoMapa y quiero más información: ${vehicleTitle} ${detailUrl}`;
  }
  if (detailUrl) {
    return `Hola, vi una publicación en AutoMapa y quiero más información: ${detailUrl}`;
  }
  if (vehicleTitle) {
    return `Hola, vi este vehículo en AutoMapa y quiero más información: ${vehicleTitle}`;
  }
  return "Hola, vi una publicación en AutoMapa y quiero más información.";
}

export function buildDealerProfileContactMessage({ dealerProfileUrl } = {}) {
  const profileUrl =
    dealerProfileUrl || (typeof window !== "undefined" ? window.location.href : null);
  if (profileUrl) {
    return `Hola, vi tu perfil en AutoMapa y quiero más información sobre tus vehículos disponibles: ${profileUrl}`;
  }
  return "Hola, vi tu perfil en AutoMapa y quiero más información sobre tus vehículos disponibles.";
}

export function buildDealerWhatsappUrl({ listing, dealer, detailUrl, message }) {
  const rawNumber =
    listing?.dealerWhatsapp ||
    dealer?.whatsapp ||
    dealer?.mainWhatsapp ||
    listing?.dealerPhone ||
    dealer?.phone ||
    null;
  const normalized = normalizeWhatsappNumber(rawNumber);
  if (!isValidWhatsappNumber(normalized)) return null;

  const text =
    message ||
    buildDealerContactMessage({
      listing,
      detailUrl: detailUrl || (typeof window !== "undefined" ? window.location.href : null),
    });

  return buildWhatsappHref(normalized, text);
}
